<script setup lang="ts">
defineSlots<{
  default: () => any
}>()
</script>

<template>
  <div class="mint-card">
    <div class="mint-card-content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'MintCardAnimatedWrapper'
}
</script>

<style scoped lang="scss">
@property --angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@property --border-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes border-rotate {
  0% {
    --angle: 0deg;
    --border-angle: 0deg;
  }
  100% {
    --angle: 360deg;
    --border-angle: 360deg;
  }
}

.mint-card {
  @apply mt-2 rounded-lg shadow-lg relative;
  padding: 2px;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: calc(0.5rem - 2px);
    padding: 2px;
    background: conic-gradient(
      from var(--border-angle),
      rgba(92, 143, 250, 0.3) 0deg,
      rgba(92, 143, 250, 0.5) 60deg,
      rgba(92, 143, 250, 0.8) 120deg,
      rgba(92, 143, 250, 1) 180deg,
      rgba(92, 143, 250, 0.8) 240deg,
      rgba(92, 143, 250, 0.5) 300deg,
      rgba(92, 143, 250, 0.3) 360deg
    );
    background-clip: padding-box;
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask: 
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
    animation: border-rotate 10s linear infinite;
    z-index: 0;
  }

  .mint-card-content {
    @apply flex items-center justify-start gap-x-2 px-3 py-2 w-full relative;
    background-color: #21252C;
    border-radius: calc(0.5rem);
    gap: 0.5rem 0.75rem;
    z-index: 1;
    min-height: 50px;

    @include sm {
      @apply flex-col items-start gap-x-1.5 px-2.5 py-2;
      gap: 0.375rem 0.5rem;
      min-height: 70px;
    }
  }
}
</style>

